'use es6';

export const getUserLanguage = () => {
  if (window.I18n && window.I18n.lang) {
    return window.I18n.lang;
  }

  return 'en';
};